module.exports = __webpack_public_path__ + "img/23_79.aa2bc7ef.png";